// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MainContentMeuHotelContatos_sectionTitle__FuBYV","placeholderShimmer":"MainContentMeuHotelContatos_placeholderShimmer__4OSHO"};